import * as yup from "yup"

export const validationSchema = yup.object().shape({
    mr_action_task_code: yup.string().label("Action task code").required().min(2).max(3),
    mr_action_task_name: yup.string().label("Action task name").required().max(100, "Must be 100 characters or less"),
    description: yup.string().label("Description").optional()
})